import config from '@/api/config'
import environments from '@/shared/constants/environments'

// Every visitor that reaches dashly.connect() counts toward the Dashly monthly quota.
const DASHLY_APP_ID = '1374-26cda167614069f7d8549c67864'

const ALLOWED_ENVIRONMENTS = [environments.PRODUCTION]

// Simple bots don't wait for delayed scripts, so they never become a Dashly visitor.
const LOAD_DELAY_MS = 1100

export function initDashly () {
  const environment = String(config.environment || '').toLowerCase()
  if (!ALLOWED_ENVIRONMENTS.includes(environment)) return

  setTimeout(loadDashly, LOAD_DELAY_MS)
}

function loadDashly () {
  // Verbatim Dashly install snippet (Settings › Code for the installation), app ID from DASHLY_APP_ID.
  /* eslint-disable */
  !function(){function t(t,e){return function(){window.dashlyasync.push(t,arguments)}}if("undefined"==typeof dashly){var e=document.createElement("script");e.type="text/javascript",e.async=!0,e.src="https://cdn.dashly.app/api.min.js",document.getElementsByTagName("head")[0].appendChild(e),window.dashly={},window.dashlyasync=[],dashly.settings={};for(var n=["connect","track","identify","auth","onReady","addCallback","removeCallback","trackMessageInteraction"],a=0;a<n.length;a++)dashly[n[a]]=t(n[a])}}(),dashly.connect(DASHLY_APP_ID);
  /* eslint-enable */

  // Path only, no query string — URLs can carry emails or tokens.
  window.dashly.identify({
    hostname: window.location.hostname,
    landing_path: window.location.pathname
  })
}
